module.exports = __webpack_public_path__ + "product-pure-powder-capsule-01.jpg?87309420a8062e3529b6fa2e20fd13c3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-pure-powder-capsule-01.jpg
// module id = 83
// module chunks = 0